import React from "react";

import AnimateIconExclamation from "../icons/animate-icon-exclamation.jsx";
import AnimateIconBacteria from "../icons/animate-icon-bacteria.jsx";
import AnimateIconRingBell from "../icons/animate-icon-ring-bell.jsx";

import sectionImg from "../images/section-image-information.jpg"
import sectionImgMobile from "../images/section-image-information-mobile.jpg"

import Form from "./Form.jsx";

function Information() {
  return (
    <div>
      <div className="banner information banner-tall img-fluid">
        <div className="container m-padding banner-padding">
          <div className="row">
            <div className="col-md-8 col-sm-6"></div>
            <div className="col-md-4 col-sm-6 pt-5 no-pad-m-y">
							<h1 className="display-3 fw-bold color-1 compatil-bold mb-5 mb">Chlorhexidine Sensitivity Information</h1>
              <h4 className="postheader fw-bold color-1 compatil-bold mb-5">As with all drugs and chemicals, there may be a chance of allergic reaction. The prevalence of this is low, and the benefits of chlorhexidine use for CLABSI prevention significantly outweigh its risks.<sup>1,2</sup></h4>
            </div>
          </div>
        </div>
      </div>

			<div className="display-section bg-blue">
        <div className="container m-padding pt-5">
          <div className="row">
            <div className="col-md-1 col-sm-12"></div>
            <div className="col-md-11 col-sm-12">
              <h1 className="open-sans text-white mb-5 align-center-m"><strong>The risk is low.</strong></h1>
            </div>
          </div>
        </div>
        <div className="container m-padding">
          <div className="row pb-5">
            <div className="col-md-1 col-sm-12"></div>
            {/* col 1 */}
            <div className="col-md-4 col-sm-12 flex-v">
              <div className="row">
                <h1 className="compatil-bold xxl-text text-white align-center-m"><strong>&lt;1<span className="xxl-sup">%</span></strong></h1>
              </div>
            </div>

            {/* col 2 */}
            <div className="col-md-5 col-sm-6 flex-v">
              <div className="row px-5 w-mobile">
                <h3 className="compatil-bold color-1 desktop"><strong> The estimated incidence of chlorhexidine&#8209;induced anaphylaxis was 0.78 per 100,000 exposures.<sup>1</sup>*</strong></h3>
                <h3 className="compatil-bold color-1 mobile"><strong> The estimated incidence <br></br>of chlorhexidine&#8209;induced anaphylaxis was 0.78 per 100,000 exposures.<sup>1</sup>*</strong></h3>
              </div>
            </div>
          </div>
          <div className="row pb-1">
            <div className="col-md-1 col-sm-12"></div>
            <div className="col-md-6 col-sm-6">
              <p className="ref-text open-sans color-3">*According to the Royal College of Anaesthetists' allergen survey conducted in 2018.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="info-section">
        <div className="container m-padding py-5">
          <div className="row pad-m-y">
            <div className="col-md-1 col-sm-12"></div>
            <div className="col-md-11 col-sm-12">
              <h2 className="compatil-bold fw-bold color-1 mb-3">The risks of CLABSIs are growing.</h2>
            </div>
          </div>
        </div>
        <div className="container m-padding pb-5 no-pad-m-y">
          <div className="row pb-5">
            <div className="col-md-1 col-sm-12"></div>

            {/* col 1 */}
            <div className="col-md-4 col-sm-6">
              <div className="row">
                <h2 className="open-sans color-1 mb-5 mb sm"><strong>Power of Chlorhexidine</strong></h2>
                <h1 className="compatil-bold xl-text color-2 mb-2 no-break"><strong>67-100<sup className="sup-lg">%</sup></strong></h1>
                <h2 className="open-sans color-1 no-margin sm"><strong>CLABSI reduction</strong></h2>
                <h5 className="open-sans color-1 mb-4">with Arrowg+ard Blue Plus™ <span class="no-break">Catheters<sup>3-6</sup></span></h5>
              </div>
            </div>

            {/* col 2 */}
            <div className="col-md-6 col-sm-6 border-left blue">
              <div className="row">
                <h2 className="open-sans color-1 mb-4"><strong>CLABSI Risks</strong></h2>
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-3 text-center icon-left icon-pad">
                  <AnimateIconBacteria />
                </div>
                <div className="col-md-8 col-sm-8 text-right">
									<h1 className="compatil-bold fw-bold color-2 no-margin">7% increase</h1>
                  <h3 className="compatil-bold fw-bold color-1 mb-5">in CLABSIs in acute care hospitals from 2020 to 2021<sup>2</sup></h3>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-6 text-center icon-left icon-pad">
                  <AnimateIconExclamation />
                </div>
                <div className="col-md-8 col-sm-6 text-right">
									<h1 className="compatil-bold fw-bold color-2 no-margin">12%-15%<br></br> expected increase</h1>
                  <h3 className="compatil-bold fw-bold color-1 mb-2">in hospital stay, morbidity, and mortality<sup>2</sup></h3>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

			<div className="display-section bg-dark-blue pad-m-b">
        <div className="container m-padding py-5">
          <div className="row py-5">
            <div className="col-md-1 col-sm-12"></div>
						<div className="col-md-2 col-sm-12 px-5">
              <AnimateIconRingBell />
						</div>
            <div className="col-md-9 col-sm-12">
              <h3 className="compatil-bold fw-bold text-white mb-3">Have a patient with a suspected chlorhexidine allergy? </h3>
							<h4 className="open-sans min text-white mb-3">Below are suggestions for how to manage patients with this type of condition.</h4>
							<ul className="open-sans min text-white mb-3">
								<h4 className="open-sans min mb-3"><li>Emphasize taking patient history and reviewing anesthesia records</li></h4>
								<h4 className="open-sans min mb-3"><li>Perform proactive chlorhexidine allergy tests</li></h4>
								<h4 className="open-sans min mb-3"><li>For patients with a confirmed allergy, provide an allergy card or bracelet for easy identification and avoid chlorhexidine-containing drugs or medical devices</li></h4>
							</ul>
            </div>
          </div>
        </div>
			</div>

			<div className="container max desktop">
        <div className="row">
          <div className="bg-grey split-width flex-v">
            <div className="split-text-col col-md-7 offset-md-3 py-5 bg-grey">
              <h2 className="fw-bold color-2 compatil-bold pt-5">Determined Commitment</h2>
              <h4 className="open-sans color-1 pb-4 pt-2">Teleflex remains committed to being your preferred vascular access partner and providing accurate and relevant data to best inform your clinical decisions.</h4>
              <div className="left-line color-1 mb-5">
                <h4 className="fw-bold open-sans"><strong>The choice to use an antimicrobial&#8209;protected catheter should be made with patients in mind—to protect and defend against CLABSI&#8209;causing pathogens.<sup>7</sup></strong></h4>
              </div>
            </div>
          </div>
        
          <div className="col-md-6 col-sm-6">
            <img src={sectionImg} alt="" className="img-fluid full-height" />
          </div>
        </div>
      </div>

      <div className="container max mobile">
        <div className="row bg-grey">
          <div className="col-md-6">
            <img src={sectionImgMobile} alt="" className="img-fluid" />
          </div>
          <div className="col-md-6 pb-5 pad-m-y m-padding">
            <h2 className="fw-bold color-2 compatil-bold m-padding">Determined Commitment</h2>
            <h4 className="open-sans min color-1 pb-4 pt-2 m-padding">Teleflex remains committed to being your preferred vascular access partner and providing accurate and relevant data to best inform your clinical decisions.</h4>
            <div className="left-line color-1 m-padding">
                <h4 className="fw-bold open-sans min"><strong>The choice to use an antimicrobial&#8209;protected catheter should be made with patients in mind—to protect and defend against CLABSI&#8209;causing pathogens.<sup>7</sup></strong></h4>
              </div>
          </div>
        </div>
      </div>

      <Form formId={1264} />
      {/* references */}
      <div className="references container pb-5">
        <div className="row pt-5 ref-text open-sans color-3">
          <p>References:
            <ol>
              <li>Cook TM, Harper NJN, Farmer L, et al. Anaesthesia, surgery, and life-threatening allergic reactions: protocol and methods of the 6th National Audit Project (NAP6) of the Royal College of Anaesthetists. <i>Br J Anaesth</i>. 2018;121(1):124-133. doi:10.1016/j.bja.2018.04.001</li>
              <li>Toor H, Farr S, Savla P, Kashyap S, Wang S, Miulli DE. Prevalence of central line-associated bloodstream infections (CLABSI) in intensive care and medical-surgical units. <i>Cureus</i>. 2022;14(3):e22809. doi:10.7759/cureus.22809</li>
              <li>Rupp ME, Lisco SJ, Lipsett PA, et al. Effect of a second-generation venous catheter impregnated with chlorhexidine and silver sulfadiazine on central catheter-related infections: a randomized, controlled trial. <i>Ann Intern Med</i>. 2005;143(8):570-580. doi:10.7326/0003-4819-143-8-200510180-00007</li>
              <li>Lorente L, Lecuona M, Jiménez A, et al. Chlorhexidine-silver sulfadiazine-impregnated venous catheters save costs. <i>Am J Infect Control</i>. 2014;42(3):321-324. doi:10.1016/j.ajic.2013.09.022</li>
              <li>Lorente L, Lecuona M, Jiménez A, et al. Cost/benefit analysis of chlorhexidine-silver sulfadiazine-impregnated venous catheters for femoral access. <i>Am J Infect Control</i>. 2014;42(10):1130-1132. doi:10.1016/j.ajic.2014.06.027</li>
              <li>Lorente L, Lecuona M, Jiménez A, et al. Chlorhexidine-silver sulfadiazine-impregnated venous catheters are efficient even at subclavian sites without tracheostomy. <i>Am J Infect Control</i>. 2016;44(12):1526-1529. doi:10.1016/j.ajic.2016.04.236</li>
              <li>Ryder MA, et al. Reduction of Extraluminal Bacterial Colonization Using Chlorhexidine Antimicrobial-coated PICC Catheters in a Clinically Simulated Ovine Model. Infusion Nurses Society Annual Convention and Industrial Exhibition; 2012.</li>
            </ol>
          </p>
          <p className="pb-4">Rx Only</p>
          <p>Contraindications:</p>
          <p>The Arrowg+ard Blue™ and Arrowg+ard Blue Plus™ Catheters are contraindicated for patients with known hypersensitivity to chlorhexidine, silver sulfadiazine and/or sulfa drugs.</p>
          <p>Clinical assessment of the patient must be completed to ensure no contraindications exist. Arrowg+ard Blue Advance™ Catheters are contraindicated in the following areas:</p>
          <p>
            <ul className="no-margin pb-1">
              <li>Patients with known hypersensitivity to chlorhexidine</li>
              <li>In presence of device-related infections</li>
              <li>In presence of previous or current thrombosis in the intended vessel or along the catheterized vessel pathway</li>
            </ul>
          </p>
          <p className="pb-4">No correlation between <i>in vitro/in vivo</i> testing methods and clinical outcomes have currently been ascertained.</p>
          <p className="sm">Teleflex, the Teleflex logo, Arrow, Arrowg+ard Blue, Arrowg+ard Blue Advance, and Arrowg+ard Blue Plus are trademarks of Teleflex Incorporated or its affiliates, in the U.S. and/or other countries. All other trademarks are trademarks of their respective owners. MC-008512</p>
        </div>
      </div>
    </div>
  );
}

export default Information;
